import Button from '@ingka/button';
import arrowClockwiseIcon from '@ingka/ssr-icon/paths/arrow-clockwise';
import { translate } from '@repo/phrase';
import { getNotifier } from '@repo/utils';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';

import { TELEMETRY_LOGS, logTelemetry } from '@/lib/telemetry.lib';

interface Props {
    source: 'asset_list' | 'asset_details';
}

export const QueryFetchingIndicator = ({ source }: Props) => {
    const queryClient = useQueryClient();
    const notifier = getNotifier();
    const isFetching = useIsFetching() > 0;

    return (
        <Button
            iconOnly
            size="small"
            type="tertiary"
            ssrIcon={arrowClockwiseIcon}
            loading={isFetching}
            loadingSrText={translate('loading_text')}
            onClick={() => {
                logTelemetry('info', TELEMETRY_LOGS.RefreshClicked, {
                    refresh: { source },
                });
                void queryClient.invalidateQueries({ refetchType: 'active' }, { throwOnError: true }).then(() => {
                    notifier?.add({
                        title: translate('refresh_notification_title'),
                        message: translate('refresh_notification_body'),
                    });
                });
            }}
            aria-label={translate('refresh')}
        />
    );
};
